export enum ReportingActionType {
  FETCH_POWER_BI_ACCESS_DETAILS = 'FETCH_POWER_BI_ACCESS_DETAILS',
  FETCH_POWER_BI_CONTRACTS_ACCESS_DETAILS = 'FETCH_POWER_BI_CONTRACTS_ACCESS_DETAILS',
  FETCH_POWER_BI_CONTRACT_REPORT_ACCESS_DETAILS = 'FETCH_POWER_BI_CONTRACT_REPORT_ACCESS_DETAILS'
}
